const tabIndicatorDefaultStyle = theme => {
  const style = {
    background: theme.tokens.ComponentTabsIndicatorColor,
    height: '4px'
  };
  return style;
};
export default tabIndicatorDefaultStyle;